// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__mont_6914a7', '__mont_Fallback_6914a7'","fontWeight":700,"fontStyle":"normal"},"className":"__className_6914a7","variable":"__variable_6914a7"};